<ion-header>
  <ion-toolbar>
    <ion-title>Select Items</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closePopover()">Done</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-searchbar [(ngModel)]="searchTerm" (ionInput)="filterItems()"></ion-searchbar>

  <ion-list>
    <ion-item lines="none">
      <ion-checkbox slot="start" [(ngModel)]="selectAllChecked" (ionChange)="toggleSelectAll()" labelPlacement="end">
        Select All
      </ion-checkbox>
    </ion-item>

    <ion-item *ngFor="let item of filteredItems" lines="none">
      <ion-checkbox
        slot="start"
        [checked]="isChecked(item)"
        (ionChange)="toggleItem(item)"
        labelPlacement="end"
        >
        {{ item.name }}
      </ion-checkbox>
    </ion-item>
  </ion-list>
</ion-content>
